import checkout from "./form7";

const {
  formField7: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune
  },
} = checkout;

const initialValues7 = {
  [endow.name]: "",
  [departmentLevel.name]: "",
  [subordinateToTheDepartment.name]: "",
  [city.name]: "",
  [district.name]: "",
  [commune.name]: "",
};

export default initialValues7;
